import { render, staticRenderFns } from "./levelThree.vue?vue&type=template&id=fa925d36&scoped=true&"
import script from "./levelThree.vue?vue&type=script&lang=js&"
export * from "./levelThree.vue?vue&type=script&lang=js&"
import style0 from "./levelThree.vue?vue&type=style&index=0&id=fa925d36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa925d36",
  null
  
)

export default component.exports